<div class="flex flex-col">
    <div id="tooltip-holder" class="absolute">
        <div #versionTooltip role="tooltip" class="absolute z-50 inline-block w-[171px] h-[240px] shadow rounded-lg left-[-181px] bg-contain invisible"></div>
    </div>
    <div #titleOuter class="shadow">
        <a [attr.href]="deckUrl">
            <div #titleInner class="p-2 text-faded-90 hover:cursor-pointer hover:text-white">
                {{ deckWithCard.deckName }}
            </div>
        </a>
    </div>
    <div>
        @for (layerWithCard of deckWithCard.layers ; track layerWithCard.layerName) {
            @for (matchingCard of layerWithCard.cards ; track matchingCard.itemId) {
                @if ((matchingCard.count + matchingCard.specialCount)) {
                    <a [attr.href]="getCardUrl(matchingCard)">
                        <div 
                            class="flex flex-row gap-1 p-1 hover:cursor-pointer hover:bg-ponder-linkhover hover:bg-opacity-15" 
                            [ngClass]="{'bg-ponder-linkhover bg-opacity-20' : isFocusedCard(matchingCard.itemId), 'pt-2' : $first, 'pb-2' : $last }"
                            (mouseenter)="onVersionHover(matchingCard.itemId)"
                            (mouseleave)="onVersionStopHover()">
                            <div class="w-[12ch]">
                                @if ($first) {
                                    {{ layerWithCard.layerName }}
                                }
                            </div>
                            <div class="truncate w-[18ch]">
                                {{ matchingCard.setName }}
                            </div>
                            <div class="w-[10ch]">
                                #{{ matchingCard.setIndex }}
                            </div>
                            <div class="text-center w-[3ch]">
                                @if (matchingCard.count) {
                                    {{ matchingCard.count }}
                                }
                            </div>
                            <div class="text-center text-foil-dark w-[3ch]">
                                @if (matchingCard.specialCount) {
                                    {{ matchingCard.specialCount }}
                                }
                            </div>
                        </div>
                    </a>
                }
            }
        }
    </div>
</div>